/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../../orchestration/page';
import * as import4 from '../../../orchestration/navigation.service';
import * as import5 from '../../../../../node_modules/angular2-qrcode/lib/angular2-qrcode.ngfactory';
import * as import6 from 'angular2-qrcode';
import * as import7 from './qr-code-page.component';
import * as import8 from '../../../orchestration/navigation-params';
const styles_QrCodePageComponent:any[] = ([] as any[]);
export const RenderType_QrCodePageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_QrCodePageComponent,
  data: {}
}
);
export function View_QrCodePageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),4,7,'div',[
      [
        'class',
        'qr-container'
      ]
      ,
      [
        'id',
        'qr-container'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'qr-container-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'qr-code',([] as any[]),(null as any),(null as any),(null as any),import5.View_QRCodeComponent_0,import5.RenderType_QRCodeComponent)),
    import0.ɵdid(573440,(null as any),0,import6.QRCodeComponent,[import0.ElementRef],{
      level: [
        0,
        'level'
      ]
      ,
      size: [
        1,
        'size'
      ]
      ,
      value: [
        2,
        'value'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,7,'div',[[
        'class',
        'qr-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'qr-text-label'
      ]
      ,
      [
        'id',
        'qr-label'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      ':\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'qr-text-code'
      ]
      ,
      [
        'id',
        'qr-code'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.QrCodePageComponent = v.component;
    ck(v,2,0);
    const currVal_0:any = 'M';
    const currVal_1:any = 200;
    const currVal_2:any = co.value;
    ck(v,12,0,currVal_0,currVal_1,currVal_2);
  },(ck,v) => {
    var co:import7.QrCodePageComponent = v.component;
    const currVal_3:any = co.message;
    ck(v,19,0,currVal_3);
    const currVal_4:any = co.displayValue;
    ck(v,22,0,currVal_4);
  });
}
function View_QrCodePageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-qr-code-page',([] as any[]),(null as any),(null as any),(null as any),View_QrCodePageComponent_0,RenderType_QrCodePageComponent)),
    import0.ɵdid(49152,(null as any),0,import7.QrCodePageComponent,[import8.NavigationParams],(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import7.QrCodePageComponent])
  ]
  ,(null as any),(null as any));
}
export const QrCodePageComponentNgFactory:import0.ComponentFactory<import7.QrCodePageComponent> = import0.ɵccf('woa-qr-code-page',import7.QrCodePageComponent,View_QrCodePageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ui-elements/qr-code/qr-code-page/qr-code-page.component.ngfactory.ts